import { DeleteIcon } from '@/components/ui/Icons';

interface DeleteProjectActionProps {
  projectId: string;
  projectName: string;
  onDelete: (id: string) => void;
  onClose: () => void;
  disabled?: boolean;
}

export function DeleteProjectAction({
  projectId,
  projectName,
  onDelete,
  onClose,
  disabled,
}: DeleteProjectActionProps) {
  const handleClick = () => {
    if (disabled) return;
    if (window.confirm(`Удалить проект «${projectName}»?`)) {
      onClose();
      onDelete(projectId);
    }
  };

  return (
    <button
      type="button"
      className="context-menu__action context-menu__action_danger"
      onClick={handleClick}
      disabled={disabled}
      role="menuitem"
    >
      <DeleteIcon size={18} />
      <span>Удалить</span>
    </button>
  );
}
